import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const PageListCheckIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M11.318 4.99957V4.79547C11.318 4.38126 10.9822 4.04547 10.568 4.04547H2.88637C2.47215 4.04547 2.13637 4.38126 2.13637 4.79547V13.7496C2.13637 14.1638 2.47215 14.4996 2.88637 14.4996H5.99965C6.27564 14.4996 6.49941 14.7236 6.49965 14.9996C6.49965 15.2757 6.27579 15.4996 5.99965 15.4996H2.88637C1.91987 15.4996 1.13637 14.7161 1.13637 13.7496V4.79547C1.13637 3.82897 1.91987 3.04547 2.88637 3.04547H10.568C11.5345 3.04547 12.318 3.82897 12.318 4.79547V4.99957C12.318 5.27572 12.0942 5.49957 11.818 5.49957C11.5419 5.49948 11.318 5.27566 11.318 4.99957Z"
      fill="currentColor"
    />
    <path
      d="M13.8638 5.5V3.25C13.8638 2.28356 13.0802 1.5001 12.1138 1.5H3.54546C3.26931 1.5 3.04546 1.27614 3.04546 1C3.04546 0.723858 3.26931 0.5 3.54546 0.5H12.1138C13.6325 0.500096 14.8638 1.73128 14.8638 3.25V5.5C14.8638 5.77608 14.6399 5.9999 14.3638 6C14.0877 6 13.8638 5.77614 13.8638 5.5Z"
      fill="currentColor"
    />
    <path
      d="M7.20001 6.29999C7.47615 6.29999 7.70001 6.52385 7.70001 6.79999C7.70001 7.07613 7.47615 7.29999 7.20001 7.29999H4.20001C3.92387 7.29999 3.70001 7.07613 3.70001 6.79999C3.70001 6.52385 3.92387 6.29999 4.20001 6.29999H7.20001Z"
      fill="currentColor"
    />
    <path
      d="M5.90019 8.77271C6.17624 8.77281 6.40019 8.99663 6.40019 9.27271C6.40019 9.54878 6.17624 9.7726 5.90019 9.77271H4.2C3.92385 9.77271 3.7 9.54885 3.7 9.27271C3.7 8.99656 3.92385 8.77271 4.2 8.77271H5.90019Z"
      fill="currentColor"
    />
    <path
      d="M5.35039 11.3182C5.62635 11.3184 5.85039 11.5422 5.85039 11.8182C5.85039 12.0942 5.62635 12.318 5.35039 12.3182H4.2C3.92385 12.3182 3.7 12.0943 3.7 11.8182C3.7 11.542 3.92385 11.3182 4.2 11.3182H5.35039Z"
      fill="currentColor"
    />
    <path
      d="M11.25 7C13.5972 7 15.5 8.90279 15.5 11.25C15.5 13.5972 13.5972 15.5 11.25 15.5C8.90279 15.5 7 13.5972 7 11.25C7 8.90279 8.90279 7 11.25 7ZM13.3145 9.62793C13.0713 9.40474 12.6929 9.42089 12.4697 9.66406L10.4961 11.8135L9.76465 11.0166L9.7207 10.9736C9.49437 10.7723 9.14789 10.7712 8.91992 10.9805C8.69224 11.1897 8.66365 11.5347 8.84473 11.7773L8.88379 11.8242L10.0566 13.1016C10.1698 13.2248 10.3297 13.2949 10.4971 13.2949C10.6642 13.2948 10.8235 13.2247 10.9365 13.1016L13.3506 10.4717C13.5734 10.2286 13.5573 9.85107 13.3145 9.62793Z"
      fill="#33AB6F"
    />
  </svg>
);
